export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#FDFBF7" className="dark:fill-ink" />
    <path
      d="M32 47c-8.4-6.3-15-11.3-15-18.6 0-4.7 3.5-8.3 8.1-8.3 2.8 0 5.3 1.5 6.9 3.9 1.6-2.4 4.1-3.9 6.9-3.9 4.6 0 8.1 3.6 8.1 8.3 0 7.3-6.6 12.3-15 18.6z"
      fill="#9E1B1B"
    />
    <path
      d="M13 52.5c6.2-3.5 12.4-5.2 19-5.2s12.8 1.7 19 5.2"
      stroke="#C5A059"
      strokeWidth="3.6"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5" data-testid="site-logo">
    <LogoMark />
    <span
      className={`font-serif text-xl font-bold tracking-tight ${
        dark ? "text-ivory" : "text-ink"
      }`}
    >
      MyHeart<span className="text-crimson">Gives</span>
      <span className="text-gold">.</span>
    </span>
  </span>
);
